export const py = { base: '6', md: '12' };
export const px = { base: '4', md: '8', lg: '24', xl: '36' };
